<template>
  <!-- 库存查询（按商品 / 按批次） -->
  <div class="inventory-list">
    <list-page>
      <div class="tabs-header">
        <div class="tab-item" :class="activeTab === 0 ? 'active' : ''" @click="switchTab(0)">按商品查询</div>
        <div class="tab-item" :class="activeTab === 1 ? 'active' : ''" @click="switchTab(1)">按批次查询</div>
      </div>

      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <product-select  v-model="searchInfo.productId" placeholder="请选择商品" :multi="true">
            <template #prefix>商品名称</template>
          </product-select>
          <el-select v-model="searchInfo.warehouseId" placeholder="请选择仓库" clearable>
            <template #prefix>仓库</template>
            <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
        </template>
      </search-condition>

      <!-- 按商品查询 -->
      <template v-if="activeTab === 0">
        <list-table>
          <yq-table :data="dataList" height="100%" stripe border page-name="inventoryProduct">
            <yq-table-column label="仓库名称" prop="warehouseName" min-width="180rem">
              <template v-slot="{row}">{{getWarehouseName(row.warehouseId)}}</template>
            </yq-table-column>
            <yq-table-column label="商品(SKU)名称" prop="productName" min-width="220rem" :show-overflow-tooltip="true"/>
            <yq-table-column label="基本单位" prop="unitNameBase" width="120rem" align="center"/>
            <yq-table-column label="数量" prop="qty" width="120rem" align="right">
              <template v-slot="{row}">
                <a v-if="row.serialEnabled === 1" @click="openSerial(row)">{{row.qty}}</a>
                <span v-else>{{row.qty}}</span>
              </template>
            </yq-table-column>
            <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="180rem" :show-overflow-tooltip="false">
              <template v-slot="{row}">
                <table-button v-if="row.serialEnabled === 1" @click="openSerial(row)">序列号</table-button>
                <table-button @click="openLog(row)">变更记录</table-button>
                <table-button @click="openBatch(row)">批次</table-button>
              </template>
            </yq-table-column>
          </yq-table>
        </list-table>
      </template>

      <!-- 按批次查询 -->
      <template v-else>
        <list-table>
          <yq-table :data="dataList" height="100%" stripe border page-name="inventoryBatch">
            <yq-table-column label="批次号" prop="batchNumber" width="180rem"/>
            <yq-table-column label="商品(SKU)" prop="productName" min-width="220rem" :show-overflow-tooltip="true"/>
            <yq-table-column label="仓库" prop="warehouseName" min-width="180rem">
              <template v-slot="{row}">{{getWarehouseName(row.warehouseId)}}</template>
            </yq-table-column>
            <yq-table-column label="基本单位" prop="unitNameBase" width="120rem" align="center"/>
            <yq-table-column label="数量" prop="qty" width="120rem" align="right"/>
          </yq-table>
        </list-table>
      </template>

      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <!-- 序列号弹窗 -->
    <el-dialog v-model="showSerial" :title="`序列号列表 · ${currentRow ? currentRow.productName : ''}`" dialog-width="3" :close-on-click-modal="false">
      <dialog-table>
        <div class="serial-tags">
          <span class="serial-tag" v-for="(s, i) in currentSerialList" :key="i">{{s.serialNumber || s}}</span>
        </div>
      </dialog-table>
      <template #footer>
        <page-button @click="showSerial = false">关闭</page-button>
      </template>
    </el-dialog>

    <!-- 变更记录弹窗 -->
    <el-dialog v-model="showLog" :title="`数量变更记录 · ${currentRow ? currentRow.productName : ''}`" dialog-width="3" :close-on-click-modal="false">
      <dialog-table>
        <yq-table :data="currentLogList || []" border stripe>
          <yq-table-column label="单据编号" prop="billNo"/>
          <yq-table-column label="单据类型" prop="billType" width="120rem" align="center">
            <template v-slot="{row}">
              <el-tag size="small" :type="billTypeTag(row.billType)">{{billTypeName(row.billType)}}</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="变更数量" prop="changeQty" width="120rem" align="right">
            <template v-slot="{row}">
              <span :style="{color: Number(row.changeQty) > 0 ? 'var(--el-color-success)' : 'var(--el-color-danger)'}">{{Number(row.changeQty) > 0 ? '+' : ''}}{{row.changeQty}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="操作员" prop="operatorName" width="120rem"/>
          <yq-table-column label="时间" prop="createdTime" width="180rem" class-name="muted"/>
        </yq-table>
      </dialog-table>
    </el-dialog>

    <!-- 批次弹窗 -->
    <el-dialog v-model="showBatch" :title="`当前有效批次 · ${currentRow ? currentRow.productName : ''}`" dialog-width="2" :close-on-click-modal="false">
      <dialog-table>
        <yq-table :data="currentBatchList || []" border stripe>
          <yq-table-column label="批次号" prop="batchNumber" width="180rem"/>
          <yq-table-column label="商品数量" prop="qty" align="right"/>
          <yq-table-column label="库存均价" prop="priceAvg" align="right"/>
          <yq-table-column label="批次入库时间" prop="createdTime" class-name="muted"/>
        </yq-table>
      </dialog-table>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import stockApi from "@/api/normal/stock/stockApi";
import productSerialApi from "@/api/normal/product/productSerialApi";
import ProductSelect from "@/components/h5/product/ProductSelect.vue";
import billTypeUtil from "@/views/h5/common/stock/BillTypeUtil";
import commonDataApi from "@/api/normal/common/commonDataApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "InventoryList",
  components: {
    DialogTable, YqTableColumn, TableButton, ProductSelect,
    SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      activeTab: 0,
      searchInfo: {pageNumber: 1},
      dataList: [],
      warehouseOptions: [],
      showSerial: false,
      showLog: false,
      showBatch: false,
      currentRow: null,
      currentSerialList: [],
      currentLogList: [],
      currentBatchList: [],
      billType: [ // 单据类型，和后端InventoryBillType对应
        {name: "采购入库", type: 1, style: "success"},
        {name: "采购退货", type: 50, style: "warning"},
        {name: "销售出库", type: 101, style: "warning"},
        {name: "销售退货", type: 150, style: "success"},
        {name: "盘点报溢", type: 201, style: "success"},
        {name: "组装入库", type: 202, style: "success"},
        {name: "盘点报损", type: 250, style: "warning"},
        {name: "组装出库", type: 251, style: "warning"},
        {name: "其它入库", type: 901, style: "success"},
        {name: "其它出库", type: 950, style: "warning"},
      ],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.init();
    this.resetSearch();
  },
  methods: {
    // 从仓库列表中获取仓库名称
    getWarehouseName(id) {
      return this.warehouseOptions.find(item => item.id === id)?.warehouseName || ''
    },
    init() {
      commonDataApi.queryAllWarehouse().then(list => this.warehouseOptions = list);
    },
    switchTab(i) {
      this.activeTab = i;
      this.resetSearch();
    },
    async queryList() {
      // 按商品查询查总库存(od_stock)；按批次查询查批次库存(od_stock_batch)
      const api = this.activeTab === 0 ? stockApi.queryList : stockApi.queryBatchList;
      const {records, totalCount} = await api(this.searchInfo);
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    // 序列号
    async openSerial(row) {
      this.currentRow = row;
      const list = await productSerialApi.queryByProduct(row.productId);
      this.currentSerialList = list || [];
      this.showSerial = true;
    },
    // 变更记录
    async openLog(row) {
      this.currentRow = row;
      const list = await stockApi.queryLog({productId: row.productId, skuId: row.skuId, warehouseId: row.warehouseId});
      this.currentLogList = list || [];
      this.showLog = true;
    },
    // 批次（从 od_stock_batch 查询该商品在该仓库的有效批次）
    async openBatch(row) {
      this.currentRow = row;
      const list = await stockApi.queryBatchByProduct(row.warehouseId, row.productId, row.skuId);
      this.currentBatchList = list || [];
      this.showBatch = true;
    },
    billTypeTag(type) {
      return billTypeUtil.getBillTypeTag(type);
    },
    billTypeName(type) {
      return billTypeUtil.getBillTypeName(type);
    }
  }
};
</script>

<style lang="scss" scoped>
.inventory-list {
  height: 100%;
  .tabs-header {
    display: flex;
    gap: 0;
    border-bottom: 1px solid var(--yq-border-color);
    background: #fff;
    border-radius: 8px 8px 0 0;
    .tab-item {
      padding: 12px 22px;
      font-size: 14px;
      color: var(--yq-font-color-tips);
      cursor: pointer;
      border-bottom: 2px solid transparent;
      margin-bottom: -1px;
      &:hover { color: var(--el-color-primary); }
      &.active {
        color: var(--el-color-primary);
        border-bottom-color: var(--el-color-primary);
        font-weight: 600;
      }
    }
  }
  .serial-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    .serial-tag {
      background: var(--el-color-primary-light-9);
      color: var(--el-color-primary);
      padding: 3px 10px;
      border-radius: 4px;
      font-size: 13px;
    }
  }
  .muted { color: var(--yq-font-color-desc); font-size: 12px; }
}
</style>
